/// <amd-module name="VSSUI/Components/Table/TableBreakpoint" />
import * as React from "react";

import { IObservableValue, ObservableLike } from "VSS/Core/Observable";

import { Breakpoint } from "VSSUI/Breakpoint";

import { ITableBreakpointProps } from "./TableBreakpoint.Props";

export function TableBreakpoint(props: ITableBreakpointProps): JSX.Element {
    const breakpoints: number[] = [];

    const onBreakpoint = function(breakpointIndex: number, breakpoint: number) {
        const { columnWidths } = props.breakpoints[Math.max(0, breakpointIndex)];
        for (let index = 0; index < columnWidths.length; index++) {
            if (ObservableLike.isObservable(props.columnWidths[index])) {
                (props.columnWidths[index] as IObservableValue<number>).value = columnWidths[index];
            }
        }

        // Notify the owner if the responsive udpate property was supplied.
        if (props.onBreakpoint) {
            props.onBreakpoint(breakpointIndex, breakpoint);
        }
    };

    // Compute the breakpoints from the table definition.
    for (let index = 0; index < props.breakpoints.length; index++) {
        breakpoints.push(props.breakpoints[index].breakpoint);
    }

    // Compute the set of breakpoints needed for the responsive columns.
    return <Breakpoint breakpoints={breakpoints} onBreakpoint={onBreakpoint} />;
}
